import React, { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Tooltip } from "@mui/material";
import { Visibility as VisibilityIcon, Close as CloseIcon } from "@mui/icons-material";
import { intl } from "dmsbasereact";

/**
 * JSONViewerButton Component
 * @component
 *
 * @description
 * Botão que abre um modal exibindo dados JSON formatados.
 *
 * @param {Object} props
 * @param {string} props.label - Label do botão
 * @param {Object|null} props.data - Dados JSON para exibir
 * @returns {JSX.Element}
 */
export const JSONViewerButton = ({ label, data }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <Button
                variant="outlined"
                size="small"
                startIcon={<VisibilityIcon />}
                onClick={handleOpen}
                disabled={!data}
            >
                {label}
            </Button>

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    {label}
                    <Tooltip title={intl.get("Tooltip.Action.Close").d("Close")}>
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Tooltip>
                </DialogTitle>
                <DialogContent dividers>
                    <pre style={{
                        backgroundColor: '#f5f5f5',
                        padding: '16px',
                        borderRadius: '4px',
                        overflow: 'auto',
                        maxHeight: '500px',
                        fontSize: '13px',
                        margin: 0
                    }}>
                        {data ? JSON.stringify(data, null, 2) : intl.get("NoData").d("No data")}
                    </pre>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        {intl.get("Close").d("Close")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
